import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useApi } from "../lib/api";
import { PageHeader, Loader } from "../components/kit";
import { FeeTypes } from "../components/fees/FeeTypes";
import { ClassPlans } from "../components/fees/ClassPlans";

const tabCls = "rounded-full px-4 py-1.5 data-[state=active]:bg-blue-500 data-[state=active]:text-white";

export default function FeeSettings() {
  const { data: school } = useApi("/school");
  return (
    <div>
      <PageHeader eyebrow="Finance" title="Fee Types & Class Fee Management" subtitle="Choose which fees your school charges and set amounts class by class for each session. Existing fee records are never changed."
        actions={<Link to="/fees" className="btn-ghost" data-testid="fee-settings-back"><ArrowLeft size={16} /> Back to fees</Link>} />
      <Tabs defaultValue="plans">
        <TabsList className="mb-6 bg-white/5 border border-white/10 rounded-full p-1 h-auto">
          <TabsTrigger value="plans" className={tabCls} data-testid="tab-class-plans">Class fee structure</TabsTrigger>
          <TabsTrigger value="types" className={tabCls} data-testid="tab-fee-types">Fee types</TabsTrigger>
        </TabsList>
        <TabsContent value="plans">{school ? <ClassPlans defaultYear={school.academic_year} /> : <Loader />}</TabsContent>
        <TabsContent value="types"><FeeTypes /></TabsContent>
      </Tabs>
    </div>
  );
}
